export default "__VITE_ASSET__CRbH7n9r__"